import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DynamicTableModule } from 'src/app/dynamic-table/dynamic-table.module';
import { TranslateModule } from '@ngx-translate/core';
import { DvirDetailComponent } from './dvir-detail.component';
import { AngularMaterialModule } from 'src/app/shared/module/angular-material.module';
import { ReactiveFormsModule } from '@angular/forms';
import { ApplicationPipesModule } from "../../shared/module/applicationPipesModule";
@NgModule({
    declarations: [DvirDetailComponent],
    exports: [DvirDetailComponent],
    imports: [
        CommonModule,
        DynamicTableModule,
        TranslateModule,
        AngularMaterialModule,
        ReactiveFormsModule,
        ApplicationPipesModule,
    ]
})
export class DvirModule { }